// extracted by mini-css-extract-plugin
export default {"variables":"\"variables.css\"","first-table-shrink-width":"1050px","pageContainer":"OrderDetailsLayout_pageContainer__inT3v","pageLoader":"OrderDetailsLayout_pageLoader__DMMSq"};